import gql from "graphql-tag";

export const API_TOTAL_REVENUE = gql`
  subscription ViewFacilityRevenue($where: view_facility_revenue_bool_exp!) {
    view_facility_revenue_aggregate(where: $where) {
      aggregate {
        count
      }
      nodes {
        total_amount_spent
        start_at
        stop_at
        meter_start_at
        meter_stop_at
        power_type
        is_fleet
        facility_id
        facility_name
        user_id
        hours_consumed
        units_consumed
        session_by_time
        session_by_unit
        session_by_price
        created_at
        charger_name
        connector_id
        penalty_fee
        penalty_paid
        payment_paid
        penalty_paid_at
        payment_paid_at
      }
    }
  }
`;

export const API_TOTAL_REVENUE_QUERY = gql`
  query ViewFacilityRevenue($where: view_facility_revenue_bool_exp!) {
    view_facility_revenue_aggregate(where: $where) {
      aggregate {
        count
      }
      nodes {
        total_amount_spent
        start_at
        stop_at
        meter_start_at
        meter_stop_at
        power_type
        is_fleet
        facility_id
        facility_name
        user_id
        hours_consumed
        units_consumed
        session_by_time
        session_by_unit
        session_by_price
        created_at
        charger_name
        connector_id
        penalty_fee
        penalty_paid
        payment_paid
        penalty_paid_at
        payment_paid_at
        payment_plan
      }
    }
  }
`;

export const API_PORTS_SUBSCRIPTION = gql`
  subscription ApiPorts($where: api_chargerport_bool_exp!) {
    api_chargerport(where: $where) {
      port_type
      power_type
      port_status
      connector_id
      updated_at
      api_charger {
        status
        name
        is_connected
        api_facility {
          name
        }
      }
      api_chargersessions(
        limit: 1
        where: {
          api_chargerport: { port_status: { _in: ["Charging", "Finishing"] } }
        }
      ) {
        transaction_id
        session_id
        api_user {
          token
          name
        }
      }
    }
  }
`;

export const API_FACILITY_COUNT_SUBSCRIPTION = gql`
  subscription ApiFacilityCountSubscription($facility_id: [bigint!]!) {
    api_state {
      api_facilities_aggregate(where: { id: { _in: $facility_id } }) {
        aggregate {
          count(columns: id)
        }
      }
      name
    }
  }
`;
export const API_CURRENCY_SUBSCRIPTION = gql`
  subscription ApiCurrencySubscription($token: String!) {
    api_user(where: { token: { _eq: $token } }) {
      api_country {
        currency
      }
    }
  }
`;

export const API_CHARGER_COUNT = gql`
  subscription ApiChargerUsed($where: api_charger_bool_exp!) {
    api_charger_aggregate(where: $where) {
      aggregate {
        count
      }
      nodes {
        name
        api_facility {
          id
          name
        }
        api_chargerports {
          connector_id
          updated_at
        }
      }
    }
  }
`;
